import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Progress } from 'antd';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Header from '../../components/Header';
import { MenuDetalheCurso } from '../../components/MenuDetalheCurso/index';
import { Tags } from '../../components/Tags/index';
import { useCursoContext } from '../../context/CursoContext';

import { ICursoEscolaFranquiaFullDTO } from '../../models/happy-code-api.model';
import { useCursoEscolaFranquiaService } from '../../services/curso-escola-franquia.service';
import { formatMoney } from '../../util/format';
import './style.css';

export const CursosCreateStep6: React.FunctionComponent = () => {
  const { curso, setRevisao } = useCursoContext();
  const history = useHistory();
  const goTo = (url) => history.push(url);
  const [cursoEscolaFranquia, setCursoEscolaFranquia] = useState<ICursoEscolaFranquiaFullDTO>();
  const cursoEscolaFranquiaService = useCursoEscolaFranquiaService();

  const findCursoEscolaFranquia = () => {
    if (curso.tipoCurso.id === 11) {
      cursoEscolaFranquiaService.findCustom(curso.id)
        .then(response => {
          setCursoEscolaFranquia(response.data)
        })
        .catch((e) => console.log(e))
    }
  }

  useEffect(() => {
    setRevisao(true);
    findCursoEscolaFranquia();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="container-fondo">
      <Header />
      <div className="progress">
        <Progress className="progress-user" percent={100} strokeLinecap="square" showInfo={false} />
      </div>
      <MenuDetalheCurso />
      <div className="franquia" style={{ backgroundColor: '#F5F5F9' }}>
        <div className="franquia-row">
          <h5>Revisão de Dados</h5>
          <div className="row-revisao">
            <div className="box-revisao">
              <div className="dados">
                <Button id="editar-step-1" className="button-line" onClick={() => goTo("/cursos/create/step-1")}>Editar</Button>
                <h4>Dados Básicos</h4>
                <div className="nome">
                  <h5>nome do curso</h5>
                  <span style={{ fontSize: 18 }}>{curso.descricao}</span>
                </div>
                <div className="dados-franquia" id="cursos-info">
                  <div className="cpf" id="cursos-info">
                    <h6>Quant. de aulas</h6>
                    <span>{curso.duracao}</span>
                  </div>
                  <div className="cpf" id="cursos-info">
                    <h6>duraçãoem min</h6>
                    <span>{curso.duracaoMinutos}</span>
                  </div>
                </div>
                <div className="dados-franquia" id="cursos-info">
                  <div className="cpf" id="cursos-info">
                    <h6>NEGÓCIO</h6>
                    <span>{curso.negocio.descricao}</span>
                  </div>
                  <div className="cpf" id="cursos-info">
                    <h6>TIPO</h6>
                    <span>{curso.tipoCurso.descricao}</span>
                  </div>
                </div>
              </div>
              <div className="line" style={{ marginBottom: 20 }}></div>
              <div className="dados">
                <Button id="editar-step-2" className="button-line" onClick={() => goTo("/cursos/create/step-2")}>Editar</Button>
                <h4>Modo de Aplicação</h4>
                <div id="data-info">
                  <Tags tipo={curso.modalidade.descricao} />
                </div>
              </div>
              <div className="line" style={{ marginBottom: 20 }}></div>
              <div className="dados">
                <Button id="editar-step-3" className="button-line" onClick={() => goTo("/cursos/create/step-3")}>Editar</Button>
                {curso.cursoPaises.length > 0 ?
                  <>
                    <h4>Paises</h4>
                    {curso.cursoPaises.map((cursoPais) =>
                      <div id="user-franquias-revisao" key={cursoPais.id}>
                        <h4>{cursoPais.paisNome}</h4>
                      </div>)}
                  </>
                  : curso.cursoClusters.length > 0 ?
                    <>
                      <h4>Clusters</h4>
                      {curso.cursoClusters.map((cursoCluster) =>
                        <div id="user-franquias-revisao" key={cursoCluster.id}>
                          <h4>{cursoCluster.clusterCodigo}</h4>
                        </div>)}
                    </>
                    : curso.cursoUnidades.length > 0 &&
                    <>
                      <h4>Franquias</h4>
                      {curso.cursoUnidades.map((cursoUnidade) =>
                        <div id="user-franquias-revisao" key={cursoUnidade.id}>
                          <h4>{cursoUnidade.unidadeDescricao}</h4>
                        </div>)}
                    </>
                }
              </div>
              {cursoEscolaFranquia ?
                <div className="dados">
                  <div className="line" style={{ marginBottom: 20 }}></div>
                  <h4>Grupo</h4>
                  <div id="user-franquias-revisao" key={cursoEscolaFranquia?.grupo.nomeFantasia}>
                    <h4>{cursoEscolaFranquia?.grupo.nomeFantasia}</h4>
                  </div>
                </div>
                : null}
              <div className="line" style={{ marginBottom: 20 }}></div>
              <div className="dados">
                <Button id="editar-step-4" className="button-line" onClick={() => goTo("/cursos/create/step-4")}>Editar</Button>
                <h4>Matrícula</h4>
                <div className="nome">
                  <h5>Preço Mínimo Matrícula</h5>
                  <span style={{ fontSize: 18 }}>{formatMoney(curso.valorMensalidadeMinimo)}</span>
                </div>
                <div className="dados-franquia" id="cursos-info">
                  <div className="cpf" id="cursos-info">
                    <h6>Valor split</h6>
                    <span>{formatMoney(curso?.valorSplitMatricula)}</span>
                  </div>
                  <div className="cpf" id="cursos-info">
                    <h6>Quant. Parcelas</h6>
                    <span>{curso?.numeroMaxParcelas}</span>
                  </div>
                </div>
                <div className="dados-franquia" id="cursos-info">
                  <div className="cpf" id="cursos-info">
                    <h6>Valor split taxa</h6>
                    <span>{formatMoney(curso?.valorSplitTaxaMatricula)}</span>
                  </div>
                  <div className="cpf" id="cursos-info">
                    <h6>Prorrogação dias</h6>
                    <span>{curso?.numeroProrrogacaoDiasMatricula}</span>
                  </div>
                </div>
              </div>
              <div className="line" style={{ marginBottom: 20 }}></div>
              <div className="dados">
                <Button id="editar-step-4" className="button-line" onClick={() => goTo("/cursos/create/step-5")}>Editar</Button>
                <h4>Rematrícula</h4>
                <div className="nome">
                  <h5>Preço Mínimo Matrícula</h5>
                  <span style={{ fontSize: 18 }}>{formatMoney(curso.valorMensalidadeMinimoRematricula)}</span>
                </div>
                <div className="dados-franquia" id="cursos-info">
                  <div className="cpf" id="cursos-info">
                    <h6>Valor split</h6>
                    <span>{formatMoney(curso?.valorSplitRematricula)}</span>
                  </div>
                  <div className="cpf" id="cursos-info">
                    <h6>Quant. Parcelas</h6>
                    <span>{curso?.numeroParcelasMaximoRematricula}</span>
                  </div>
                </div>
                <div className="dados-franquia" id="cursos-info">
                  <div className="cpf" id="cursos-info">
                    <h6>Valor split taxa</h6>
                    <span>{formatMoney(curso?.valorSplitTaxaRematricula)}</span>
                  </div>
                  <div className="cpf" id="cursos-info">
                    <h6>Prorrogação dias</h6>
                    <span>{curso?.numeroProrrogacaoDiasRematricula}</span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div className="botao-voltar-revisao">
        <Button id="voltar" className="button-second" icon={<ArrowLeftOutlined rev={undefined} />} onClick={() => history.goBack()}>
          Voltar
        </Button>
      </div>
    </div >
  )
}